var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/popover_cross.7ee78b0d.png","uri@2x": __webpack_public_path__ + "static/media/popover_cross.f5c0eef0.png","uri@3x": __webpack_public_path__ + "static/media/popover_cross.f8fce491.png",
    width: 16,
    height: 16
});